module.exports = __webpack_public_path__ + "c0c8b707421262c5f29afb5426f0a405.svg";